export default __webpack_public_path__ + "static/media/nos-marque.fbdf566d.jpg";